<div class="row d-flex justify-content-center">
    <div class="alert border rounded alert-info d-flex justify-content-center align-items-center col-4" role="alert">
        <p>Traitement en cours, veuillez patienter</p>
    </div>
</div>
<div class="row d-flex justify-content-center">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" class="col-4">
            <circle cx="50" cy="50" r="40" fill="none" stroke="#00ffdb" stroke-width="8">
              <animate 
                attributeName="r" 
                from="20" 
                to="40" 
                dur="1.5s" 
                repeatCount="indefinite"
                begin="0s"
                fill="freeze"
              />
              <animate 
                attributeName="stroke-opacity" 
                from="1" 
                to="0" 
                dur="1.5s" 
                repeatCount="indefinite"
                begin="0s"
                fill="freeze"
              />
            </circle>
            <circle cx="50" cy="50" r="20" fill="#00ff00">
              <animate 
                attributeName="r" 
                from="10" 
                to="30" 
                dur="1.5s" 
                repeatCount="indefinite"
                begin="0s"
                fill="freeze"
              />
              <animate 
                attributeName="fill-opacity" 
                from="1" 
                to="0" 
                dur="1.5s" 
                repeatCount="indefinite"
                begin="0s"
                fill="freeze"
              />
            </circle>
          </svg>
    
</div>